import { useContext, useState } from 'react';
import {
  ApiResidenceValuePropertyResponse,
  ApiResidenceValuePropertyInformationResponse,
  ApiResidenceValuePropertyValueResponse,
  ApiResidenceValuePropertyValueRequest,
  ApiResidenceValuePropertyValue
} from '../../../../../@types';
import { API } from '../../../../../services';
import { useIntl } from 'react-intl';
import { HomeValueContext } from '../context';
import { CalculatorsHomeValueFormFields } from '../../../../../@types/features/calculators';
import { utilsHomeValueGetPostData } from '../utils';

export const homeValueUseResidenceValueHook = () => {
  const intl = useIntl();
  const [extensions, setExtensions] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);
  const [propertyInformation, setPropertyInformation] =
    useState<ApiResidenceValuePropertyInformationResponse>([]);
  const [busy, setBusy] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { setPropertyInformation: setPropertyInformationContext } = useContext(HomeValueContext);

  const getAdressInformation = async (postalCode: string, houseNumber: string) => {
    try {
      setBusy(true);
      setError(null);
      const res = await API.get<ApiResidenceValuePropertyResponse>(
        `residencevalue/getaddressinformation?${getQueryString(
          postalCode.replace(/ /g, ''),
          houseNumber,
          ''
        )}`
      );

      let foundExtensions: { label: string; value: string }[] = [];

      if (res.length > 0) {
        foundExtensions = res.map((item) => {
          return {
            label: item.houseNumberExt ? item.houseNumberExt : 'n.v.t',
            value: item.houseNumberExt
          };
        });
      }
      setExtensions(foundExtensions);
      setBusy(false);
    } catch (err) {
      console.error(err);
      setError(
        intl.formatMessage({
          id: 'hooks.useResidenceValue.getAdressInformation.error',
          defaultMessage: 'Er is geen adres gevonden.'
        })
      );
      setExtensions([]);
      setBusy(false);
    }
  };

  const getPropertyInformation = async (
    postalCode: string,
    houseNumber: string,
    houseNumberExt: string
  ) => {
    try {
      setBusy(true);
      setError(null);
      const res = await API.get<ApiResidenceValuePropertyInformationResponse>(
        `residencevalue/getpropertyinformation?${getQueryString(
          postalCode,
          houseNumber,
          houseNumberExt
        )}`
      );
      setPropertyInformation(res);
      setPropertyInformationContext(res[0]);
      setBusy(false);
    } catch (err) {
      setError(
        intl.formatMessage({
          id: 'hooks.useResidenceValue.getPropertyInformation.error',
          defaultMessage: 'Er is iets misgegaan bij het ophalen van de gegevens.'
        })
      );
      setBusy(false);
    }
  };

  const getPropertyValue = async (
    formData: CalculatorsHomeValueFormFields
  ): Promise<ApiResidenceValuePropertyValue> => {
    return new Promise((resolve, reject) => {
      setBusy(true);
      setError(null);
      API.post<ApiResidenceValuePropertyValueResponse, ApiResidenceValuePropertyValueRequest>(
        'residencevalue/calculatepropertyvalue',
        utilsHomeValueGetPostData(formData)
      )
        .then((res) => {
          setBusy(false);
          resolve(res);
        })
        .catch((err) => {
          setError(
            intl.formatMessage({
              id: 'hooks.useResidenceValue.getPropertyValue.error',
              defaultMessage: 'Er is iets misgegaan bij het ophalen van de gegevens.'
            })
          );
          setBusy(false);
          reject(err);
        });
    });
  };

  const getQueryString = (postalCode: string, houseNumber: string, houseNumberExt: string) => {
    return `PostalCode=${postalCode}&HouseNumber=${houseNumber}&HouseNumberExt=${houseNumberExt}`;
  };

  return {
    extensions,
    propertyInformation,
    busy,
    error,
    setError,
    setExtensions,
    setPropertyInformation,
    getAdressInformation,
    getPropertyInformation,
    getPropertyValue
  };
};
